export default {
  "content": "<path d=\"M15.12 16H.88c-.478 0-.88-.383-.88-.838 0-.454.402-.838.88-.838h14.24c.478 0 .88.384.88.838 0 .455-.402.839-.88.839zM8.012 12.383c-.477 0-.88-.384-.88-.838V.838c0-.454.403-.838.88-.838s.88.384.88.838v10.707c0 .455-.403.838-.88.838z\" fill=\"#0065DC\"/><path d=\"M8.012 12.382a.897.897 0 01-.628-.24L3.265 8.19c-.35-.335-.35-.863 0-1.173.352-.335.905-.335 1.23 0l4.12 3.927c.35.335.35.863 0 1.174-.15.191-.377.264-.603.264z\" fill=\"#0065DC\"/><path d=\"M8.012 12.382a.897.897 0 01-.627-.24c-.352-.335-.352-.862 0-1.173l4.144-3.952c.351-.335.905-.335 1.23 0 .352.335.352.862 0 1.173l-4.118 3.952a.897.897 0 01-.628.24z\" fill=\"#0065DC\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};